import { useMutation, useQueryClient } from '@tanstack/react-query';
import instance from '@src/api/axiosInstance';
import { message } from 'antd';

const useDeleteTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (templateId: number) => {
      const response = await instance.delete(`/nexa/diagnostic-templates/${templateId}`);
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['diagnostic-templates']);
        queryClient.invalidateQueries(['diagnostic-modes']);
        message.success('Template deleted successfully');
      },
      onError: (error: any) => {
        const errorMessage = error.response?.data?.detail || 'Failed to delete template';
        message.error(errorMessage);
      },
    },
  );
};

export default useDeleteTemplate;
